// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"455":"f189ff21","600":"6d11444f"}[chunkId] + ".css";
};